// extracted by mini-css-extract-plugin
module.exports = {"Switch":"Switch_Switch__2GXJc","Active":"Switch_Active__2Eqtx","Disabled":"Switch_Disabled__1R9D2"};